import { Injectable } from '@angular/core'
import { ParseService } from 'src/app/parse.service'

declare global {
    interface Window {
        saq?: (arg1: string, arg2: string, arg3?: unknown) => void
    }
}

@Injectable({
    providedIn: 'root',
})
export class StackAdaptPixelService {
    constructor(private parseService: ParseService) {}

    trackAddToCart(val: number, orderID: string) {
        try {
            if (document.location.host !== 'app.wisepelican.com') {
                return
            }

            if (val <= 0) {
                return
            }

            window.saq?.('conv', '0fX6WB7dlhiBb5CivGmAlC', { revenue: val, order_id: orderID })
        } catch (err) {
            this.parseService.reportUIError(err, 'StackAdaptPixelService.trackAddToCart', '')
        }
    }

    trackSignUp() {
        try {
            if (document.location.host !== 'app.wisepelican.com') {
                return
            }

            window.saq?.('conv', 'YmpIxG1ieqoWf9X4SUCkTW')
            window.saq?.('rt', 'ZUSubluTLExDlewLDNMXd5')
            window.saq?.('rt', 's1P7BPqa6ETeuvg4e7LKsZ')
            window.saq?.('rt', 'RBmohgzvRMsd9GgbyfwC8I')
            window.saq?.('rt', 'mtt8hkWXccTm1awbv0I9Wq')
        } catch (err) {
            this.parseService.reportUIError(err, 'StackAdaptPixelService.trackSignUp', '')
        }
    }

    trackPurchase(establishmentID: string, saleAmount: number, purchaseType: 'ML' | 'MO') {
        try {
            if (document.location.host !== 'app.wisepelican.com') {
                return
            }

            if (saleAmount <= 0) {
                return
            }

            const transactionID = `${purchaseType}-${establishmentID}-${Date.now()}`
            window.saq?.('conv', 'qQHddWb68uWzrFUtQZhs8h', { revenue: saleAmount, order_id: transactionID })
            window.saq?.('lal', 'exD763y7AcVnv9buOjBCko')
            window.saq?.('rt', 'LRHo8FbyltTB3gfEgG9ZY9')
            window.saq?.('rt', 'dBvbpCLZW3zC14aOxLPL5S')
            window.saq?.('rt', 'wIY2s9W1RYWaqBp1kLDDry')
            window.saq?.('rt', 'aD6h86GHvfOeTKBxlpzXlB')
        } catch (err) {
            this.parseService.reportUIError(err, 'StackAdaptPixelService.trackPurchase', '')
        }
    }
}
